import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
const swal = Vue.prototype.$swal;

const sweetAlerts = {
  toast1(
    kind,
    msg,
    timer = 2000,
    timerProgressBar = true,
    position = "top-end"
  ) {
    const Toast = swal.mixin({
      toast: true,
      position,
      showConfirmButton: false,
      timer,
      timerProgressBar,

      onOpen: (toast) => {
        toast.addEventListener("mouseenter", swal.stopTimer);
        toast.addEventListener("mouseleave", swal.resumeTimer);
      },
    });
    Toast.fire({
      icon: kind,
      title: msg,
    });
  },
  confirmation1(
    title,
    text,
    icon = "warning",
    showCancelButton = true,
    confirmButtonColor = "#3085d6",
    cancelButtonColor = "#d33",
    confirmButtonText = "Sim"
  ) {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          title,
          text,
          icon,
          showCancelButton,
          confirmButtonColor,
          cancelButtonColor,
          confirmButtonText,
        })
        .then((result) => {
          if (result.value) {
            // utilizar async await
            resolve(true);
          }
        });
    });
  },
};

Vue.prototype.$sweetAlerts = sweetAlerts;
